// src/theme/index.js
import { extendTheme } from "@chakra-ui/react";

//
// 1. Color Mode (Light Only)
//
const config = {
  initialColorMode: "light",
  useSystemColorMode: false,
};

//
// 2. Brand Colors (Red + White)
//
const colors = {
  brand: {
    50: "#FFF5F5",
    100: "#FFE3E3",
    200: "#FFBDBD",
    300: "#FF8A8A",
    400: "#FF5A5A",
    500: "#E63946",
    600: "#CC2F3D",
    700: "#A62631",
    800: "#7D1C25",
    900: "#4D0F15",
  },
  success: "#38A169",
  error: "#E53E3E",
  warning: "#DD6B20",
};

//
// 3. Typography
//
const fonts = {
  heading: '"Inter", sans-serif',
  body: '"Roboto", sans-serif',
};

//
// 4. Component Overrides (Chakra v2‑safe)
//
const components = {
  Button: {
    baseStyle: { rounded: "md", fontWeight: 600 },
    variants: {
      solid: {
        bg: "brand.500",
        color: "white",
        _hover: { bg: "brand.600" },
      },
      outline: {
        borderColor: "brand.500",
        color: "brand.500",
        _hover: { bg: "brand.50" },
      },
      subtle: {
        bg: "brand.50",
        color: "brand.700",
        _hover: { bg: "brand.100" },
      },
    },
  },

  Input: {
    baseStyle: {
      field: {
        rounded: "md",
        borderColor: "brand.100",
        _focus: {
          borderColor: "brand.500",
          boxShadow: "0 0 0 1px #E63946",
        },
      },
    },
  },

  Select: {
    baseStyle: {
      field: {
        rounded: "md",
        borderColor: "brand.100",
        _focus: {
          borderColor: "brand.500",
          boxShadow: "0 0 0 1px #E63946",
        },
      },
    },
  },

  Alert: {
    baseStyle: { rounded: "md" },
  },
};

//
// 5. Final Theme Export
//
const theme = extendTheme({
  config,
  colors,
  fonts,
  components,
});

export default theme;
